// removed by extract-text-webpack-plugin
module.exports = {"root":"index-root-3nQ2Z","main":"index-main--YaIL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pc-layout/index.less
// module id = 737
// module chunks = 0